import { Button, } from "@bracket/ui";



export declare type SwapButtonProps = {
	label: string;
	isDisabled?: boolean;
	busy?: boolean;
	busyText?: string;
	handleClick: () => void;
};



/**
 * A button component specifically designed for swap/trade actions.
 * Handles the main action (approve/swap) in swap interfaces.
 * Shows loading state during transactions and can be disabled based on conditions.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.label - Text to display on the button
 * @param {boolean} [props.isDisabled=false] - Whether the button is disabled
 * @param {boolean} [props.busy=false] - Whether to show loading state
 * @param {() => void} props.handleClick - Click handler function
 * @returns {JSX.Element} A button component for swap actions
 */
export const SwapButton = ({
	label,
	isDisabled = false,
	busy = false,
	busyText,
	handleClick,
}: SwapButtonProps) => {
	return (
		<Button
			onClick={handleClick}
			disabled={isDisabled}
			label={label}
			busyText={busyText}
			busy={busy}
			innerColor="primary_on"
		/>
	);
};
